export const noConversation = 'noconversation';
export const noConversationPathnameConst = "/chat/noconversation/nomessage";
export const noMessagesConst = "You haven't received any messages yet.";
export const noMessagesFullConst = "You haven't received any messages yet.";
export const messagePrefixConst = "From ServiceChannel: ";

